<template>
  <div class="content">
  
    <div class="line_border_title2 career_page">
      <p class="header_title_page">报告信度</p>
      <p class="line"></p>
    </div>
    <div class="table">
      <table class="gridtable">
        <tr>
          <td>综合信度指数</td>
          <td colspan="2">{{PagePart.comprehensive}} (参考值：70↑)</td>
          
        </tr>
        <tr>
          <td>作答起止时间</td>
          <td colspan="2">{{ PagePart.startTime }} - {{ PagePart.endTime }}</td>
        </tr>
        <tr>
          <td rowspan="3">作答时间</td>
          <td>限时能力类测试</td>
          <td>
            {{ PagePart.limitedTime }} 分钟（参考时间：26.7-66.8分钟）
          </td>
        </tr>
        <tr>
          <td
            style="
              background: #fff;
              font-size: 14px;
              font-weight: 400;
              border: 1px dashed #ccc;
            "
          >
            非限时能力类测试
          </td>
          <td>
            {{ PagePart.nonLimitedTime}} 分钟（参考时间：18.3-50.1分钟）
          </td>
        </tr>
        <tr>
          <td
            style="
              background: #fff;
              font-size: 14px;
              font-weight: 400;
              border: 1px dashed #ccc;
            "
          >
            量表类测试
          </td>
          <td>{{ PagePart.questionnaireTime }} 分钟（参考时间：11.7-43.3分钟）</td>
        </tr>
        <tr>
          <td>作答一致性</td>
          <td colspan="2">{{ PagePart.consistency }} (参考值：0.70↑)</td>
        </tr>
        <tr>
          <td>作答规律性</td>
          <td colspan="2">{{ PagePart.regularity }} 次</td>
        </tr>
        <tr>
          <td>社会称许性</td>
          <td colspan="2">{{ PagePart.approval }}（参考值：0.70↓）</td>
        </tr>
      </table>
    </div>
    <div class="line_box2">
      <p class="line_title career_page" style="font-size:20px">
        
        <img
          src="../../../../../public/imgs/cepingreport/page_feng.png"
          alt=""
        />
        测评结果总览
      </p>
      <p class="line_info">你的生涯测评结果如下图所示：</p>
    </div>
    <div class="page1_img">
      <img src="../../../../../public/imgs/cepingreport/page_1.png" alt="图" />
      <span class="text_mind">{{resultOverview.mind}}</span>
      <div class="rg rg_ab">
        <h5>人格</h5>
        <div class="box_border" v-if="resultOverview.mbti">
            <p>{{resultOverview.mbti.fourYard }}</p>
            <ul>
                <li v-for="(m,index) in resultOverview.mbti.comment" :key="index">{{m}}</li>
            </ul>
        </div>
      </div>
      <div class="zn rg_ab">
        <h5>智能</h5>
        <div class="box_border">
            <p></p>
            <ul>
                <li v-for="(m,index) in resultOverview.intelligent" :key="index">{{m}}</li>
            </ul>
        </div>
      </div>
      <div class="xq rg_ab">
        <i class="userRun"></i>
        <h5>兴趣</h5>
        <div class="box_border" v-if="resultOverview.hobby">
            <p>{{resultOverview.hobby.threeYard}}</p>
            <ul>
                <li v-for="(m,index) in resultOverview.hobby.comment" :key="index">{{m}}</li>
            </ul>
        </div>
      </div>
      <div class="jzg rg_ab">
        <h5>价值观</h5>
        <div class="box_border3">
            <p></p>
            <ul>
                <li><span>主：</span><p>{{resultOverview.professionValue&&resultOverview.professionValue[0]}}</p></li>
                <li><span>副：</span><p>{{resultOverview.professionValue&&resultOverview.professionValue[1]}}{{resultOverview.professionValue&&resultOverview.professionValue[2]}}</p></li>
            </ul>
        </div>
      </div>
      <div class="zhuany rg_ab">
        <h5>专业</h5>
         <div class="box_border2" v-for="(m,index) in resultOverview.professional" :key="index">
            <p>{{num2[index]}}</p>
            <ul>
                <li>{{m}}</li>
            </ul>
        </div>
      </div>
      <div class="zhiy rg_ab">
        <h5>职业</h5>
         <div class="box_border2" v-for="(m,index) in resultOverview.career" :key="index">
            <p>{{num[index]}}</p>
            <ul>
                <li>{{m}}</li>
            </ul>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
        num2:[
        "推荐一",
        "推荐二",
        "推荐三",
        "推荐四",
        "推荐五",
        "推荐六",
        ],
      num: [
        "推荐一",
        "推荐二",
        "推荐三",
        "推荐四",
      ],
    };
  },
  props: {
    PagePart: {
      type: Object,
    },
    resultOverview: {
      type: Object,
    },
  },

  created() {
    
  },
  mounted(){
     
  },
  methods: {
    formatTime(msTime) {
      let time = msTime / 1000;
      let day = Math.floor(time / 60 / 60 / 24);
      let hour = Math.floor(time / 60 / 60) % 24;
      let minute = Math.floor(time / 60) % 60;
      let second = Math.floor(time) % 60;
      return `${hour}时${minute}分${second}秒`;
    },
  },
};
</script>

<style scoped>
@import "./report.css";
.rg_ab {
  position: absolute;
      display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
}
.rg_ab h5 {
  font-size: 16px;
  color: #fff;
  font-weight: 600;
  text-align: center;
  height: 50px;
  line-height: 50px;
}
.rg {
  bottom: 62px;
  left: 38px;
  width: 86px;
  /* height: 186px; */
  background: #aacf00;
}
.zn {
  bottom: 62px;
  left: 130px;
  width: 86px;
  height: 235px;
  /* height: 186px; */
  background: #00b3f0;
}
.xq {
  bottom: 62px;
  left: 222px;
  width: 86px;
  height: 280px;
  /* height: 186px; */
  background: #feb714;
}
.jzg {
  bottom: 62px;
  left: 315px;
  width: 100px;
  height: 320px;
  background: #fc6f6f;
}
.zhuany {
  bottom: 62px;
  left: 422px;
    width: 124px;
  height: 360px;
  /* height: 350px; */
  background: #f6a724;
}
.zhiy {
  bottom: 62px;
 left: 554px;
    width: 124px;
  height: 400px;
  /* height: 186px; */
  background: #1ca4b6;
}


.line_border_title2 p {
    line-height: 42px;
    color: #2f2f2f;
    font-weight: 500;
    font-size: 30px;
    
}
.line_border_title2 p span{
    color:#9F9E9E;
    font-size: 20px;
    margin-left: 15px;
}
.line_border_title2 .line{
    margin-top: 7px;
    height: 2px;
    width: 130px;
    background: -webkit-gradient(linear,left top,right top,from(#ffb23a),to(#19afbf));
    background: linear-gradient(90deg
,#ffb23a,#19afbf);
}
.userRun{
  position: absolute;
    top: -60px;
  display: inline-block;
  width: 50px;
  height: 57px;
  background: url("../../../../../public/imgs/cepingreport/userRun.png");
}


.table {
  margin-top: 35px;
}
.box_border{
    /* height: 100px; */
    width: 70px;
    border-radius: 10px;
    border: 1px dashed #fff;
    padding: 10px 0;
    margin-bottom: 10px;
    background: rgba(165, 231, 240, 0.2);
}
.box_border3{
    /* height: 100px; */
    width: 80px;
    border-radius: 10px;
    border: 1px dashed #fff;
    padding: 10px 0;
    margin-bottom: 10px;
    background: rgba(165, 231, 240, 0.2);
}
.box_border3 ul li{
  display: flex;
}
.box_border2{
    width: 105px;
    border-radius: 10px;
    border: 1px dashed #fff;
    padding: 10px 0;
    background: rgba(165, 231, 240, 0.2);
}
.box_border2{
    margin-bottom: 10px;
}
.box_border p,.box_border2 p,.box_border3 p{
    text-align: center;
    color: #fff;
    font-size: 14px;
    margin-bottom: 10px;
}
.box_border ul,.box_border2 ul,.box_border3 ul{
    display: flex;
    flex-direction: column;
    align-items: center;
}
.box_border ul li,.box_border2 ul li,.box_border3 ul li{
    color: #fff;
    font-size: 14px;
    padding: 0 5px;
    text-align: center;
}
table.gridtable {
  font-family: verdana, arial, sans-serif;
  font-size: 14px;
  color: #333333;
  border: 1px dashed DFDEDE;
  border-collapse: collapse;
}
table.gridtable tr td:first-child {
  background: #f9f8f8;
  font-size: 16px;
  font-weight: 600;
}
/* table.gridtable th {
    border-width: 1px;
    padding: 8px;
    border-style: solid;
    border-color: #666666;
    background-color: #dedede;
} */
table.gridtable td {
  border-width: 1px;
  padding: 10px;
  border-style: dashed;
  border-color: #dfdede;
  background-color: #ffffff;
  text-align: center;
}
.line_box2 {
  margin-top: 40px;
}
.line_title {
  font-size: 16px;
  font-weight: 600;
}
.line_info {
  font-size: 14px;
  margin-top: 20px;
}

.page1_img {
  position: relative;
  height: 540px;
  display: flex;
  justify-content: center;
  margin-bottom: 30px;
}
.page1_img img {
  position: absolute;
  bottom: 0px;
}
/*  */
.text_mind{
  position: absolute;
  bottom: 18px;
  
}
</style>